/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type IntakeAppTokenByLinkSource = typeof IntakeAppTokenByLinkSource[keyof typeof IntakeAppTokenByLinkSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntakeAppTokenByLinkSource = {
  AppointmentCommunique: 'AppointmentCommunique',
  ConsentFormCommunique: 'ConsentFormCommunique',
  PatientInfoCommunique: 'PatientInfoCommunique',
  TempoCommunique: 'TempoCommunique',
  RTMCheckIn: 'RTMCheckIn',
  RTMEnrollment: 'RTMEnrollment',
  PCCCommunique: 'PCCCommunique',
} as const;
